export const SSO_EXTERNAL_ID_COLUMN = 'SSO external ID';
export const SP_STATUS_COLUMN = 'SP';
export const NBOME_ID_COLUMN = 'NBOME ID';
export const DEMOGRAPHIC_FIELDS_TEXT = 'Demographic fields';

export const BASE_COLUMNS = {
    USER_NAME: 'User name',
    EMAIL: 'Email',
} as const;

export const NAME_COLUMNS = {
    FIRST_NAME: 'First name',
    MIDDLE_NAME: 'Middle name',
    LAST_NAME: 'Last name',
} as const;

export const COMMON_COLUMNS = {
    USER_NUMBER: 'User number',
    PASSWORD: 'Password',
    ORGANIZATION_NAMES: 'Organization names',
    ROLE: 'Role',
} as const;

export const DEMOGRAPHIC_COLUMNS = {
    DATE_OF_BIRTH: 'Date of birth',
    GENDER: 'Gender',
    PRONOUNS: 'Pronouns',
    RACE: 'Race',
    ETHNICITY: 'Ethnicity',
    COUNTRY: 'Country',
    CITY: 'City',
    STATE: 'State',
    POSTAL_CODE: 'Postal code',
    PHONE: 'Phone',
    LANGUAGES_SPOKEN: 'Languages spoken',
    EDUCATION: 'Education',
    CASTABLE_AGE_RANGE: 'Castable age range',
    CITIZENSHIP_WORKING_STATUS: 'Citizenship / Working status',
    WEIGHT_RANGE: 'Weight range',
    HEIGHT_RANGE: 'Height range',
    TATTOO: 'Tattoo',
    SCAR: 'Scar',
    EMPLOYEE: 'Employee',
    STUDENT: 'Student',
    SP_EXPERIENCE: 'SP experience',
    NOTES: 'Notes',
} as const;

export const IMPORT_ACTIONS = {
    ENABLE_SP_STATUS: 'ENABLE_SP_STATUS',
    NONE: 'NONE',
    UPSERT_USERS: 'UPSERT_USERS',
    UPSERT_USERS_WITH_SP_STATUS: 'UPSERT_USERS_WITH_SP_STATUS',
} as const;

export const UPSERT_REQUIRED_FIELDS = {
    FIRST_NAME: 'First name',
    LAST_NAME: 'Last name',
} as const;

export const WEIGHT_HEIGHT_COLUMN_NAMES = {
    WEIGHT_RANGE_LB: 'Weight range (lb)',
    WEIGHT_RANGE_KG: 'Weight range (kg)',
    HEIGHT_RANGE_FT_IN: 'Height range (ft/in)',
    HEIGHT_RANGE_CM: 'Height range (cm)',
} as const;

export const NONE = 'None' as const;
